export default __webpack_public_path__ + "static/media/chitkara_wide.35c4154d.png";